import { useTranslation } from 'react-i18next';
import SEO, { breadcrumbJsonLd } from '../../components/SEO';
import RoiCalculatorSection from '../home/components/RoiCalculatorSection';

export default function RoiCalculatorPage() {
  const { t } = useTranslation();

  return (
    <div className="pt-24">
      <SEO
        title="ROI Calculator"
        description="Estimate monthly savings from fewer delays, higher fleet utilization, and less manual dispatch. Adjust orders, fleet size, and delay cost—then book a demo to validate on your network."
        jsonLd={breadcrumbJsonLd([
          { name: 'Home', url: 'https://geofleet.ai' },
          { name: 'ROI calculator', url: 'https://geofleet.ai/roi-calculator' },
        ])}
      />
      <section className="relative pb-4 lg:pb-6 bg-gradient-to-b from-gray-50 to-white border-b border-slate-100">
        <div className="max-w-4xl mx-auto px-6 text-center pt-10 lg:pt-14">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-blue-600 mb-2">
            {t('home.roiCalculator.eyebrow')}
          </p>
          <h1
            id="roi-calculator-heading"
            className="text-3xl sm:text-4xl font-bold text-slate-900 tracking-tight mb-3"
          >
            {t('home.roiCalculator.title')}
          </h1>
          <p className="text-slate-600 text-base sm:text-lg leading-relaxed max-w-2xl mx-auto">
            {t('home.roiCalculator.subtitle')}
          </p>
        </div>
      </section>
      <RoiCalculatorSection hideIntro />
    </div>
  );
}
